module.exports = __webpack_public_path__ + "img/chatgpt-active.df18d00b.svg";